import { ProductModifierGroupSchema } from "@repo/validators";
import { useTranslation } from "react-i18next";

import type { ProductModifierGroup } from "~/providers/product-provider";
import { useProductModifierGroupManager } from "~/managers/use-product-modifier-group-manager";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  useForm,
} from "../ui/form";
import { Input } from "../ui/input";

export default function ModifierGroupForm({
  modifierGroup,
  onClose,
}: {
  modifierGroup?: ProductModifierGroup;
  onClose: (force?: boolean) => void;
}) {
  const { t } = useTranslation("common");
  const { createModifierGroup, updateModifierGroup } =
    useProductModifierGroupManager();

  const form = useForm({
    schema: ProductModifierGroupSchema,
    defaultValues: {
      name: modifierGroup?.name ?? "",
    },
  });

  const handleSubmit = form.handleSubmit(async (data) => {
    if (modifierGroup) {
      const result = await updateModifierGroup(modifierGroup.id, data);
      if (result === true) {
        form.reset();
        onClose(true);
      }
    } else {
      const result = await createModifierGroup(data);
      if (result === true) {
        form.reset();
        onClose(true);
      }
    }
  });

  return (
    <Form {...form}>
      <form
        id="modifier-group-form"
        onSubmit={handleSubmit}
        className="grid grid-cols-2 gap-2"
      >
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem className="col-span-full">
              <FormLabel>{t("ProductModifierGroup.name")}</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  placeholder={t("ProductModifierGroup.name")}
                />
              </FormControl>
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
